jQuery(document).ready(function(){
  jQuery('.a_chb').click(function(){
    jQuery('body').addClass('hideheaderblock');
  });

  jQuery("body").each(function() {
    setInterval(function(){
      var el = jQuery('.zakeke-product-button-container');
      var index = 0;
      var timer = window.setInterval(function(){
        if (index < el.length) {
          el.eq(index++).parents('body').addClass('cstbtnbdy');
        } else {
          window.clearInterval(timer);
        }
      }, 1000);
    }, 1);
  });

  function visible(el) {
  return el && !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}

function setStep(el, step) {
  if (!visible(el)) return step;

  var label = 'Step ' + step;

  if (el.classList && el.classList.contains('ns-checkbox-customise-step-label')) {
    el.textContent = label;
  } else {
    el.setAttribute('data-step', label);
  }

  return step + 1;
}

function uniqueVisibleLabels(root, selector) {
  var seen = [];

  return Array.from(root.querySelectorAll(selector)).filter(function(label) {
    var control = label.closest('.product-form__input, .product-form__input--dropdown, fieldset') || label;

    if (!visible(label) || !visible(control)) return false;
    if (seen.indexOf(label) !== -1) return false;

    seen.push(label);
    return true;
  });
}

function numberProductSteps(root) {
  root.querySelectorAll('[data-step]').forEach(function(el) {
    el.removeAttribute('data-step');
  });

  var step = 1;

  uniqueVisibleLabels(root, [
    'variant-selects .product-form__input--dropdown label',
    'variant-selects .product-form__input > label',
    'variant-radios .product-form__input > legend',
    '.product-form__input:not(.product-form__quantity):not(.product-form__txtarea):not(.ns-checkbox-customise-step) > .form__label'
  ].join(',')).forEach(function(label) {
    step = setStep(label, step);
  });

  uniqueVisibleLabels(root, '.ns-checkbox-customise-step .ns-checkbox-customise-step-label').forEach(function(label) {
    step = setStep(label, step);
  });

  uniqueVisibleLabels(root, '.product-form__txtarea label').forEach(function(label) {
    step = setStep(label, step);
  });

  step = setStep(root.querySelector('.product-form__quantity label, .quantity__label'), step);

  var customiseButton = root.querySelector('.zakeke-product-button-container');
  if (visible(customiseButton)) {
    step = setStep(customiseButton, step);
  }

  var addToCart = Array.from(root.querySelectorAll('.product-form__buttons')).find(function(el) {
    return !el.classList.contains('zakeke-product-button-container') &&
      el.querySelector('button[name="add"], .product-form__submit');
  });

  setStep(addToCart, step);
}

function runProductStepNumbers() {
  document.querySelectorAll('.product').forEach(numberProductSteps);
}

runProductStepNumbers();
setTimeout(runProductStepNumbers, 300);
setTimeout(runProductStepNumbers, 1000);
setTimeout(runProductStepNumbers, 2500);

new MutationObserver(function() {
  clearTimeout(window.__productStepTimer);
  window.__productStepTimer = setTimeout(runProductStepNumbers, 100);
}).observe(document.body, {
  childList: true,
  subtree: true
});

  jQuery('.drawer__cart-items-wrapper button[name="plus"]').click(function() {
    var $input = jQuery(this).parent().find('input');
    $input.val(parseInt($input.val()) + 1);
    $input.change();
    return false;
  });

  jQuery('.drawer__cart-items-wrapper button[name="minus"]').click(function() {
    var $input = jQuery(this).parent().find('input');
    var count = parseInt($input.val()) - 1;
    count = count < 1 ? 1 : count;
    $input.val(count);
    $input.change();
    return false;
  });

  function updateCustomiseTextField() {
    var selectedChoice = jQuery('[data-customise-choice]:checked');
    var textInput = jQuery('[data-customise-text-input]');
    var shouldCustomise = selectedChoice.val() === 'Yes';

    if (!textInput.length) return;

    if (shouldCustomise) {
      textInput.addClass('is-visible');
      textInput.prop('disabled', false);
      textInput.prop('required', true);
      textInput.attr('aria-required', 'true');
      textInput.get(0).setCustomValidity('');
    } else {
      textInput.removeClass('is-visible');
      textInput.val('');
      textInput.prop('required', false);
      textInput.prop('disabled', true);
      textInput.attr('aria-required', 'false');
      textInput.get(0).setCustomValidity('');
    }
  }

  function validateCustomiseTextField(event) {
    updateCustomiseTextField();

    var selectedChoice = jQuery('[data-customise-choice]:checked');
    var textInput = jQuery('[data-customise-text-input]');
    var shouldCustomise = selectedChoice.val() === 'Yes';

    if (!shouldCustomise || !textInput.length) return true;

    var inputEl = textInput.get(0);

    if (!jQuery.trim(textInput.val())) {
      event.preventDefault();
      event.stopPropagation();

      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }

      textInput.addClass('is-visible');
      textInput.prop('disabled', false);
      textInput.prop('required', true);
      textInput.attr('aria-required', 'true');

      inputEl.setCustomValidity('Please enter the custom text for your sign.');
      inputEl.reportValidity();
      inputEl.focus();

      return false;
    }

    inputEl.setCustomValidity('');
    return true;
  }

  jQuery(document).on('change', '[data-customise-choice]', updateCustomiseTextField);

  jQuery(document).on('input', '[data-customise-text-input]', function () {
    this.setCustomValidity('');
  });

  document.addEventListener('click', function(event) {
    var addButton = event.target.closest(
      'button[name="add"], .product-form__submit, add-to-cart-component button[type="submit"]'
    );

    if (addButton) {
      validateCustomiseTextField(event);
    }
  }, true);

  document.addEventListener('submit', function(event) {
    if (event.target.matches('form[action*="/cart/add"], form[data-type="add-to-cart-form"]')) {
      validateCustomiseTextField(event);
    }
  }, true);

  updateCustomiseTextField();
});